import { LIST_EVENTS_QUERY, ListEventsData } from '../../queries';
import { MutationHookOptions, useMutation } from 'react-apollo';
import { DELETE_EVENT_MUTATION } from './delete-event-mutation';
import { DeleteEventPayload } from './delete-event-payload';
import { DeleteEventVariables } from './delete-event-variables';
import { MutationUpdaterFn } from 'apollo-client';

const update = (
  variables: DeleteEventVariables,
): MutationUpdaterFn<DeleteEventPayload> => (cache, { data }) => {
  const query = cache.readQuery<ListEventsData>({
    query: LIST_EVENTS_QUERY,
  });
  if (data && query) {
    const {
      events: { edges },
    } = query;
    const updatedEdges = edges.filter(edge => edge.node.id !== variables.id);
    cache.writeQuery<ListEventsData>({
      query: LIST_EVENTS_QUERY,
      data: { ...query, events: { ...query.events, edges: updatedEdges } },
    });
  }
};

export const useDeleteEventMutation = (
  variables: DeleteEventVariables,
  options?: Omit<MutationHookOptions, 'mutation' | 'variables'>,
) =>
  useMutation<DeleteEventPayload, DeleteEventVariables>(DELETE_EVENT_MUTATION, {
    variables,
    update: update(variables),
    ...options,
  });
